import { useState } from "react";
import { votePoll } from "@/mocks/evaluations";

export default function Vote() {
  const [counts, setCounts] = useState(votePoll.options.map((o) => o.count));
  const [picked, setPicked] = useState<number | null>(null);

  const total = counts.reduce((a, b) => a + b, 0);
  const pctOf = (i: number) => Math.round((counts[i] / total) * 100);

  const vote = (id: number) => {
    if (picked !== null) return;
    setPicked(id);
    setCounts((prev) => prev.map((c, i) => (i === id - 1 ? c + 1 : c)));
  };

  return (
    <section id="vote" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-5xl px-4 md:px-6">
        <div className="overflow-hidden rounded-3xl border border-background-200 bg-background-100">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.1fr]">
            <div className="relative flex flex-col justify-center overflow-hidden bg-primary-500 p-7 text-background-50 md:p-9">
              <div
                className="pointer-events-none absolute inset-0"
                style={{ background: "linear-gradient(135deg, oklch(var(--primary-600) / 0.5), transparent)" }}
                aria-hidden="true"
              />
              <span className="font-bebas relative text-sm tracking-[0.2em]">STREET POLL</span>
              <h2 className="font-heading relative mt-2 text-2xl font-black leading-snug md:text-3xl">
                围观站小调查<br />
                <span className="text-accent-300">大众此刻怎么看</span>
              </h2>
              <p className="relative mt-3 text-sm leading-6 text-background-100">
                随手投一票，看看此刻围观群众的站队分布，顺便为吃瓜增加一点参与感。
              </p>
              <div className="relative mt-6 flex items-center gap-3 text-sm text-background-100">
                <i className="ri-group-line text-lg" aria-hidden="true" />
                已有 <span className="font-bebas text-2xl text-background-50">{total.toLocaleString()}</span> 人参与
              </div>
            </div>

            <div className="p-7 md:p-9">
              <h3 className="font-heading text-lg font-bold text-foreground-950">{votePoll.question}</h3>
              <p className="mt-1.5 text-xs text-foreground-500">
                <i className="ri-information-line mr-1" aria-hidden="true" />
                {votePoll.note}
              </p>

              <div className="mt-6 space-y-3">
                {votePoll.options.map((o, i) => {
                  const activePick = picked === o.id;
                  const pct = pctOf(i);
                  const barCls = ["bg-primary-500", "bg-accent-500", "bg-secondary-500", "bg-foreground-500"][i];
                  return (
                    <button
                      key={o.id}
                      type="button"
                      disabled={picked !== null}
                      onClick={() => vote(o.id)}
                      className="group w-full text-left"
                      aria-pressed={activePick}
                    >
                      <div
                        className={`flex items-center justify-between gap-3 rounded-xl border p-4 transition-colors ${
                          activePick
                            ? "border-primary-400 bg-primary-50"
                            : "border-background-200 bg-background-50 group-hover:border-background-300"
                        }`}
                      >
                        <span className="flex items-center gap-2.5 text-sm text-foreground-800">
                          <i className={`${o.icon} text-lg ${activePick ? "text-primary-500" : "text-foreground-400"}`} aria-hidden="true" />
                          {o.label}
                          {activePick && (
                            <i className="ri-checkbox-circle-fill text-primary-500" aria-hidden="true" />
                          )}
                        </span>
                        <span className="font-bebas text-lg text-foreground-600">{pct}%</span>
                      </div>
                      <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                        <div className={`h-full rounded-full ${barCls} transition-all duration-500`} style={{ width: picked !== null ? `${pct}%` : "0%" }} />
                      </div>
                    </button>
                  );
                })}
              </div>

              <p className="mt-5 text-xs text-foreground-500">
                {picked !== null
                  ? "感谢投票！你的这一票已计入统计。"
                  : "投票后即可查看各选项的实时占比。"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}